import { useThorEvent } from "@aviv-dxp/react-thor";
import { useTrackingEventsDatas } from "./useTracking";
export const useTrackingLeadForm = ({ event, av_zone, }) => {
    const EVENT_DATA = {
        ...useTrackingEventsDatas({
            displayMedium: true,
            conversionType: "mail",
            av_zone,
        }),
        event,
    };
    return useThorEvent({
        compatibilities: { GA3: false, GA4: true },
        eventData: EVENT_DATA,
    });
};
